export default __webpack_public_path__ + "static/media/rocket.c363f015.svg";